"use client";

import { BentoCardVariant, ButtonLink, TBentoCard } from "@shared/cms";
import { imageFallback } from "@shared/utils";
import { cn } from "@ubud-ui/react-ui-kit";
import Image from "next/image";
import { Subtitle } from "../subtitle";

export function BentoCard({
  title,
  variant,
  imagePosition,
  backgroundImage,
  button,
  description,
  image,
  subtitle,
  className,
  imageClassName,
}: TBentoCard) {
  const cardVariantsMap: Record<BentoCardVariant, string> = {
    default: "bg-white border-gray-200",
    primary: "bg-primary border-none",
  };

  const subtitleVariantsMap: Record<BentoCardVariant, string> = {
    default: "text-gray-700",
    primary: "text-white",
  };

  const titleVariantsMap: Record<BentoCardVariant, string> = {
    default: "text-gray-700",
    primary: "text-white",
  };

  const descriptionVariantsMap: Record<BentoCardVariant, string> = {
    default: "text-gray-500",
    primary: "text-white",
  };

  return (
    <div
      className={cn(
        "border rounded-xl flex justify-between overflow-hidden relative",
        cardVariantsMap[variant],
        imagePosition === "right" ? "flex-col md:flex-row" : "flex-col",
      )}
    >
      {backgroundImage && (
        <Image
          src={backgroundImage.url}
          alt={backgroundImage.alternativeText || backgroundImage.name || ""}
          className="w-full h-auto bg-top-left absolute top-0 left-0 z-10"
          width={backgroundImage.width || 1000}
          height={backgroundImage.height || 1000}
        />
      )}
      <div className={cn("p-6 sm:py-10 sm:pl-10 sm:pr-10", className)}>
        {subtitle && <Subtitle {...subtitle} textClass={subtitleVariantsMap[variant]} />}
        <div className="mt-4">
          <div className={cn("text-2xl sm:text-4xl font-bold mb-4", titleVariantsMap[variant])}>{title}</div>
          <div className={cn("text-base", descriptionVariantsMap[variant])}>{description}</div>
        </div>
        {button && <ButtonLink {...button} size="sm" className="mt-10" />}
      </div>
      {imagePosition === "bottom" && image && (
        <Image
          src={image.url}
          width={image.width || 1000}
          height={image.height || 1000}
          alt={image.alternativeText || image.name || ""}
          className={cn("w-full ml-auto object-cover object-bottom", imageClassName)}
          onError={imageFallback()}
        />
      )}
      {imagePosition === "right" && image && (
        <div className={cn("z-20 flex-1", imageClassName)}>
          <Image
            src={image.url}
            width={image.width || 1000}
            height={image.height || 1000}
            alt={image.alternativeText || image.name || ""}
            className="w-full h-full object-cover object-right-bottom"
            onError={imageFallback()}
          />
        </div>
      )}
    </div>
  );
}
